import { ErrorCode, ErrorName } from 'src/constants';

import { BaseError } from './BaseError';

export class GoogleRecaptchaExecuteError extends BaseError {
  constructor(message: string) {
    super(message, { code: ErrorCode.GOOGLE_RECAPTCHA_EXECUTE, name: ErrorName.GoogleRecaptchaExecute });
  }
}
